import React, { useState } from "react";
import LoadingScreen from "../../../utils/LoadingScreen";
import { ToastContainer } from "react-toastify";

const OrdersTable = ({ type, data = [], loading, onOrderClick }) => {
  const [expandedRow, setExpandedRow] = useState(null);
  const [refundModalItem, setRefundModalItem] = useState(null);

  const displayValue = (value) => {
    if (value === null || value === undefined || String(value).trim() === "") {
      return "N/A";
    }

    return value;
  };

  const displayAmount = (value) => {
    if (value === null || value === undefined || String(value).trim() === "") {
      return "N/A";
    }

    const amount = Number(value);

    if (Number.isNaN(amount)) {
      return "N/A";
    }

    return `₹ ${amount.toFixed(2)}`;
  };

  const hasEncodedEmoji = (value) => {
    if (!value) return false;

    return /\[Emoji:[^\]]+\]/i.test(String(value));
  };

  //  FAILED TABLE UI
  if (type === "failed") {
    return (
      <>
      <ToastContainer/>
      
      <div>
        {/* <div className="p-3 font-semibold border-b montserrat-font-1">
          Unsuccessful Orders
        </div> */}

       <div className="max-h-[calc(100vh-230px)] overflow-y-auto overflow-x-auto">
  <table className="w-full text-sm montserrat-font-1 border-separate border-spacing-0">
    <thead className="sticky top-0 z-20 bg-green-200 montserrat-font-1">
            <tr>
              <th className="p-3">S.No.</th>
              <th className="p-3">Date</th>
              <th className="p-3">Order ID</th>
              <th className="p-3">Customer Name</th>
              <th className="p-3">Message Send</th>
              <th className="p-3">Per Message Cost</th>
              <th className="p-3">Total Message Charges</th>
              <th className="p-3">Status</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8" className="text-center py-10">
                  <LoadingScreen text="Loading data..." />
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan="10" className="text-center py-6 text-gray-500">
                  No Records Found
                </td>
              </tr>
            ) : (
              data.map((item, i) => (
                <tr key={i} className="border-b text-center">
                  <td className="p-2">{i + 1}</td>
                  <td className="p-2">{displayValue(item.datetime)}</td>
                  <td
                    className={`p-2 ${
                      item.refrence
                        ? "text-blue-600 cursor-pointer hover:underline"
                        : "text-gray-500"
                    }`}
                    onClick={() => {
                      if (item.refrence) {
                        onOrderClick(item);
                      }
                    }}
                  >
                    {displayValue(item.refrence)}
                  </td>
                  <td className="p-2">{displayValue(item.customer_name)}</td>
                  <td className="p-2">
                    {item.message_count !== null &&
                    item.message_count !== undefined &&
                    String(item.message_count).trim() !== ""
                      ? `${item.message_count} Message(s)`
                      : "N/A"}
                  </td>
                  <td className="p-2">
                    {displayAmount(item.per_message_cost)}
                  </td>
                  <td className="p-2">{displayAmount(item.message_charges)}</td>
                  <td className="p-2">
                    <span className="px-3 py-1 bg-yellow-100 rounded-full border">
                      Unsettled
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      </div>
      </>
    );
  }

  //  COMMON TABLE (UPI / CASH / QR / CREDIT)
  return (
    <>
    <ToastContainer/>
 
    <div className="flex mt-0 flex-col h-full">
      <div className="bg-white rounded shadow">
        <div className="max-h-[calc(100vh-230px)] overflow-y-auto overflow-x-auto">
          <table className="w-full text-sm text-start border-separate border-spacing-0">
            <thead className="bg-green-100 sticky top-0 z-20">
              <tr>
                <th className="p-3 bg-green-100">S.No.</th>
                <th className="p-3 bg-green-100">Date</th>
                <th className="p-3 bg-green-100">Reference No</th>
                <th className="p-3 bg-green-100">Order Type</th>
                <th className="p-3 bg-green-100">Order ID</th>
                <th className="p-3 bg-green-100">Customer</th>
                <th className="p-3 bg-green-100">
                  Order Amount (GSt Included)
                </th>
                <th className="p-3 bg-green-100">Net Charge Deduction</th>
                <th className="p-3 bg-green-100">Net Settlement Amount</th>
                <th className="p-3 bg-green-100">Refund Status</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" className="text-center py-10">
                    <LoadingScreen text="Loading data..." />
                  </td>
                </tr>
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan="10" className="text-center py-6 text-gray-500">
                    No Records Found
                  </td>
                </tr>
              ) : (
                data.map((item, i) => {
                  const isRefunded = item.refund_status === "Y";

                  return (
                    <React.Fragment key={i}>
                      <tr
                        className={`border-b text-center transition ${
                          isRefunded
                            ? "bg-red-50 hover:bg-red-100"
                            : "hover:bg-gray-50"
                        }`}
                      >
                        <td className="p-2">{i + 1}</td>
                        <td className="p-2">
                          {item.datetime ? (
                            <>
                              <div>{item.datetime.split(" ")[0]}</div>

                              <div className="text-xs text-gray-500">
                                {item.datetime.split(" ").slice(1).join(" ") ||
                                  "N/A"}
                              </div>
                            </>
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td className="p-2">{displayValue(item.rrn)}</td>
                        <td className="p-2">
                          <div className="flex flex-col items-center gap-1">
                            <span
                              className={`px-2 py-1 rounded text-xs font-semibold ${
                                isRefunded
                                  ? "bg-red-100 text-red-700 border border-red-200"
                                  : "bg-green-100 text-green-700"
                              }`}
                            >
                              {item.order_type
                                ? item.order_type
                                    .replace(/_/g, " ")
                                    .replace(/\b\w/g, (c) => c.toUpperCase())
                                : "N/A"}
                            </span>
                          </div>
                        </td>
                        <td
                          className={`p-2 ${
                            item.refrence
                              ? "text-blue-600 cursor-pointer hover:underline"
                              : "text-gray-500"
                          }`}
                          onClick={() => {
                            if (item.refrence) {
                              onOrderClick(item);
                            }
                          }}
                        >
                          {item.refrence?.split("/")?.[0]?.trim() || "N/A"}
                        </td>
                        <td className="p-2">
                          {hasEncodedEmoji(item.customer_name) ? (
                            <div>{displayValue(item.customer_mobile)}</div>
                          ) : (
                            <>
                              <div>
                                {item.customer_name ||
                                  item.customer_mobile ||
                                  "N/A"}
                              </div>

                              {item.customer_name && (
                                <div className="text-xs text-gray-500">
                                  {displayValue(item.customer_mobile)}
                                </div>
                              )}
                            </>
                          )}
                        </td>
                        <td className="p-2 font-semibold">
                          {displayAmount(item.credit)}
                        </td>

                        <td className="p-2">
                          <div className="flex justify-between items-center">
                            <span>{displayAmount(item.totalDeduction)}</span>

                            <button
                              className="text-blue-600 text-xs"
                              onClick={() =>
                                setExpandedRow(expandedRow === i ? null : i)
                              }
                            >
                              {expandedRow === i ? "Hide" : "Details"}
                            </button>
                          </div>
                        </td>

                        <td className="p-2">
                          <div className="flex flex-col items-center gap-1">
                            <span
                              className={`font-semibold ${
                                isRefunded ? "text-red-700" : "text-gray-800"
                              }`}
                            >
                              {displayAmount(item.settlement_amount)}
                            </span>

                            {isRefunded && (
                              <span className="inline-flex items-center justify-center rounded-full border border-red-200 bg-red-100 px-2.5 py-0.5 text-[10px] font-bold text-red-700">
                                Refunded
                              </span>
                            )}
                          </div>
                        </td>

                        <td className="p-2">
                          {isRefunded ? (
                            <button
                              type="button"
                              onClick={() => setRefundModalItem(item)}
                              className="inline-flex items-center justify-center rounded-full border border-red-200 bg-red-100 px-3 py-1 text-xs font-semibold text-red-700 hover:bg-red-200"
                            >
                              View Details
                            </button>
                          ) : (
                            <span className="inline-flex items-center justify-center rounded-full border border-gray-200 bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-600">
                              Not Refund
                            </span>
                          )}
                        </td>
                      </tr>

                      {/*  EXPAND */}
                      {expandedRow === i && (
                        <tr>
                          <td
                            colSpan="10"
                            className={`p-4 text-left ${isRefunded ? "bg-red-50" : "bg-gray-50"}`}
                          >
                            {/* TITLE */}
                            <h4 className="font-semibold mb-3">
                              Breakdown of Charges
                            </h4>

                            <div className="mb-3">
                              <p className="font-medium text-gray-600">
                                WhatsApp Messaging Charges
                              </p>

                              <div className="flex justify-between">
                                <span>Messages Sent</span>
                                <span>
                                  {item.message_count !== null &&
                                  item.message_count !== undefined &&
                                  String(item.message_count).trim() !== ""
                                    ? `${item.message_count} Message(s)`
                                    : "N/A"}
                                </span>
                              </div>

                              <div className="flex justify-between">
                                <span>Per Message Cost</span>
                                <span>
                                  {displayAmount(item.per_message_cost)}
                                </span>
                              </div>

                              <div className="flex justify-between">
                                <span>Message Charges</span>
                                <span>
                                  {displayAmount(item.message_charges)}
                                </span>
                              </div>

                              <div className="flex justify-between">
                                <span>GST</span>
                                <span>{displayAmount(item.message_gst)}</span>
                              </div>

                              <div className="flex justify-between font-semibold">
                                <span>Total Messaging Cost</span>
                                <span>
                                  ₹{" "}
                                  {(
                                    Number(item.message_charges || 0) +
                                    Number(item.message_gst || 0)
                                  ).toFixed(2)}
                                </span>
                              </div>
                            </div>

                            <hr />

                            {item.payment_mode?.toLowerCase() !== "cash" && (
                              <>
                                <div className="my-3">
                                  <p className="font-medium text-gray-600">
                                    Tax Deduction
                                  </p>

                                  <div className="flex justify-between">
                                    <span>CGST</span>
                                    <span>₹ {displayAmount(item.cgst)}</span>
                                  </div>

                                  <div className="flex justify-between">
                                    <span>SGST</span>
                                    <span>₹ {displayAmount(item.sgst)}</span>
                                  </div>

                                  <div className="flex justify-between">
                                    <span>Total GST</span>
                                    <span>₹ {displayAmount(item.tax_gst)}</span>
                                  </div>
                                </div>

                                <hr />
                              </>
                            )}

                            <hr />

                            <div className="my-3">
                              <p className="font-medium text-gray-600">
                                Transaction Charges
                              </p>

                              <div className="flex justify-between">
                                <span>Gateway Charges</span>
                                <span>
                                  ₹ {displayAmount(item.gateway_charges)}
                                </span>
                              </div>

                              <div className="flex justify-between">
                                <span>GST</span>
                                <span>₹ {displayAmount(item.gateway_gst)}</span>
                              </div>
                            </div>

                            <hr />

                            <div className="my-3">
                              <p className="font-medium text-gray-600">
                                Platform Fee
                              </p>

                              <div className="flex justify-between">
                                <span>Platform Charges</span>
                                <span>₹ {displayAmount(item.charges)}</span>
                              </div>
                            </div>

                            {item.order_type === "home_delivery" && (
                              <>
                                <hr />
                                <div className="my-3">
                                  <p className="font-medium text-gray-600">
                                    Delivery Charges
                                  </p>

                                  <div className="flex justify-between">
                                    <span>Delivery Fee</span>
                                    <span>
                                      ₹ {displayAmount(item.delivery_fee)}
                                    </span>
                                  </div>
                                </div>
                              </>
                            )}

                            <hr />

                            <div className="flex justify-between font-bold mt-3 text-blue-600">
                              <span>Total Charges Deduction</span>
                              <span>
                                ₹ {displayAmount(item.totalDeduction)}
                              </span>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* refund model */}

      {refundModalItem && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
          <div className="w-[360px] rounded-xl bg-white shadow-2xl">
            <div className="flex items-center justify-between border-b px-4 py-3">
              <h3 className="text-sm font-bold text-red-700">Refund Details</h3>

              <button
                onClick={() => setRefundModalItem(null)}
                className="text-lg text-gray-400 hover:text-gray-700"
              >
                ✕
              </button>
            </div>

            <div className="space-y-3 p-4 text-sm">
              <div className="rounded-lg border border-red-100 bg-red-50 p-3">
                <p className="text-xs text-red-500">Refund Amount</p>
                <p className="mt-1 text-2xl font-bold text-red-700">
                  ₹ {displayAmount(refundModalItem.refund_amount)}
                </p>
              </div>

              <div className="rounded-lg border bg-gray-50 p-3">
                <p className="text-xs text-gray-500">Refund Remark</p>
                <p className="mt-1 font-semibold text-gray-800">
                  {refundModalItem.refundRemark || "No remark available"}
                </p>
              </div>

              <div className="rounded-lg border bg-white p-3">
                <p className="text-xs text-gray-500">Order ID</p>
                <p className="mt-1 font-semibold text-gray-800">
                  {refundModalItem.refrence?.split("/")?.[0]?.trim() ||
                    refundModalItem.orderid ||
                    "-"}
                </p>
              </div>
            </div>

            <div className="flex justify-end border-t px-4 py-3">
              <button
                onClick={() => setRefundModalItem(null)}
                className="rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default OrdersTable;
